import { Grid } from '@material-ui/core';
import React, { memo, useContext } from 'react';
import { InspectionCheCkContaxt } from './InspectionCheckProvide';

const headerTitleStyle = {
    fontSize: 11.5,
    fontWeight: 700,
    color: '#f50057',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontFamily: 'inherit'
};

export const AddCheckTableHeader = memo(({ m, PassAllbutton, className }) => {
    const { flags, changeAllChildChecks, state } = useContext(InspectionCheCkContaxt);
    const isReadOnly = Boolean(state?.isDisabled || state?.vehicleInspectionInspectorSignature);

    return (
        <Grid
            container
            spacing={1}
            alignItems="center"
            style={{
                background: '#f1f5f9',
                borderBottom: '1px solid #e2e8f0',
                padding: '3px 12px',
                margin: 0,
                width: '100%'
            }}
        >
            {flags.displayStartEvent ? (
                <>
                    <Grid item xl={5} lg={5} md={5} sm={5} xs={5}>
                        <span style={headerTitleStyle}>Checks</span>
                    </Grid>
                    <Grid item xl={1} lg={1} md={2} sm={2} xs={2} style={{ textAlign: 'center' }}>
                        <span style={headerTitleStyle}>Start Status</span>
                    </Grid>
                    <Grid item xl={6} lg={6} md={5} sm={5} xs={5}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <PassAllbutton
                                state={m.state}
                                onClick={!isReadOnly ? changeAllChildChecks('S', true, m.inspectionSheetSectionDescription) : undefined}
                                style={{ cursor: isReadOnly ? 'default' : 'pointer', pointerEvents: isReadOnly ? 'none' : 'auto', opacity: isReadOnly ? 0.6 : 1 }}
                            />
                            <span style={headerTitleStyle}>Action</span>
                        </div>
                    </Grid>
                </>
            ) : (
                <>
                    <Grid item xl={5} lg={5} md={5} sm={5} xs={5}>
                        <span style={headerTitleStyle}>Checks</span>
                    </Grid>
                    <Grid item xl={7} lg={7} md={7} sm={7} xs={7}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <PassAllbutton
                                state={m.state}
                                onClick={!isReadOnly ? changeAllChildChecks('S', true, m.inspectionSheetSectionDescription) : undefined}
                                style={{ cursor: isReadOnly ? 'default' : 'pointer', pointerEvents: isReadOnly ? 'none' : 'auto', opacity: isReadOnly ? 0.6 : 1 }}
                            />
                            <span style={headerTitleStyle}>Action</span>
                        </div>
                    </Grid>
                </>
            )}
        </Grid>
    );
});

export default AddCheckTableHeader;
